<template src="@/components/Ork/OrkReassurance.html"></template>
<style lang="scss" scoped src="@/components/Ork/OrkReassurance.scss"></style>

<script>
import {
  SfIcon,
  SfImage
} from '@storefront-ui/vue';
import { configuration } from '@/config/InstanceConfiguration';


export default {
  name: 'OrkReassurance',
  components: {
    SfIcon,
    SfImage
  },
  computed: {
    reassuranceIcons() { return configuration.footer.reassuranceIcons; }
  }
};

</script>